import { SPXAPI } from '../interfaces';
import { BASEURL, ENDPOINTS } from '../endpoints';

// Reuses `/files/multiple_link`. Pass a real email for a recipient-bound link, or
// EMPTY_RECIPIENT (lowercased) for a general unbound link — same sentinel the
// Share pane uses. Forwarding is still enforced by file policy on open/signup.
const getRecipientShareLink = async (
    API: SPXAPI,
    fileId: string,
    recipientEmail: string,
): Promise<string | null> => {
    try {
        const result = await API.post(
            BASEURL.backend(),
            ENDPOINTS.createMultipleFilesLink(),
            {
                body: {
                    files_ids: [fileId],
                    recipient_identity: recipientEmail,
                    recipient_type: 'user',
                },
            },
        );
        return result?.link ?? null;
    } catch {
        return null;
    }
};

export default getRecipientShareLink;
